import { LocalStorageIndexedDb } from './LocalStorageIndexedDb';
import { LocalStorageMemory } from './LocalStorageMemory';

const DB_NAME = 'openclassrooms-store';
const DB_STORE_NAME = 'keyval';
const DB_VERSION = 1;

let localStorage: LocalStorageIndexedDb | LocalStorageMemory;

try {
  localStorage = new LocalStorageIndexedDb(DB_NAME, DB_STORE_NAME, DB_VERSION);
} catch (e) {
  localStorage = new LocalStorageMemory();
}

export async function setItem<T = unknown>(key: string, value: T) {
  await localStorage.put(key, value);
  return value;
}

export function getItem<T = unknown>(key: string) {
  return localStorage.get<T>(key);
}

export function removeItem(key: string) {
  return localStorage.delete(key);
}

export function clearAll() {
  return localStorage.clear();
}
